/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Interop {
    export class InteropController {
        static $inject = [
            "meevo.AppSettings",
            "$rootScope",
            "$scope",
            "$sce",
            'meevo.components.logging.LoggingService',
            'meevo.plugins.interop.InteropService',
            "meevo.ContextParams",
            '$timeout',
        ];

        public url: string = null;
        public domain: string = null;
        public id: string;

        private iframeElement?: HTMLIFrameElement;
        private _watcher: any;
        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $sce: ng.ISCEService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected interopService: InteropService,
            protected contextParams: Meevo.IContextParams,
            private $timeout: ng.ITimeoutService) {
            let inputRoute: any;

            this.domain = appSettings.MEEVO_MODULES_URL;
            $scope.$on('$destroy', () => {
                if (this.iframeElement) {
                    this.interopService.removeWindow(this.iframeElement.id);
                }
                if (this._watcher) {
                    this._watcher();
                    this._watcher = null;
                }
            });

            if (Model.Guard.isSomething(contextParams.params) && Model.Guard.isSomething(contextParams.params.interopParams)) {
                this.updateTargetRoute(contextParams.params.interopParams.targetRoute);
            } else {
                this.loggingService.error(`No target route was defined for a Meevo interop module.`);
                return;
            }

            this._watcher = $scope.$watch(() => (this.contextParams && this.contextParams.params && this.contextParams.params.interopParams), (interopParams: any) => {
                if (Model.Guard.isSomething(contextParams.params) && interopParams && interopParams.id) {
                    const existing = this.interopService.interopRegisteredWindows.find(w => w.id === interopParams.id);
                    existing && this.interopService.updateInteropRoute(interopParams.id, interopParams.targetRoute);
                }
            });
        }

        updateTargetRoute(newRoute: string) {
            if (Model.Guard.isNothing(this.contextParams.params)) {
                this.contextParams.params = { interopParams: { } };
            }
            if (Model.Guard.isNothing(this.contextParams.params.interopParams)) {
                this.contextParams.params.interopParams = { };
            }
            let inputRoute = newRoute;

            // Append any staged querystring params to the iframe URL.
            // consumeQueryParams reads and clears so params only apply once.
            const qp = this.interopService.consumeQueryParams(inputRoute);
            let qs = '';
            if (qp) {
                const searchParams = new URLSearchParams();
                for (const key in qp) {
                    if (qp.hasOwnProperty(key)) {
                        searchParams.append(key, qp[key]);
                    }
                }
                qs = '?' + searchParams.toString();
            }
            const url = `${this.domain}/${inputRoute}${qs}`;

            this.url = this.$sce.trustAsResourceUrl(url);
            const id = this.contextParams.params.interopParams.id || newRoute;
            this.registerIframe(id);
        }

        /**
         * Resolve the iframe element and hand its window to InteropService.
         *
         * The element's id comes from `id="{{interop.id}}"`, so it only exists once a
         * digest has rendered it — which is why this cannot run synchronously. It
         * used to run behind a flat `$timeout(1000)`, an arbitrary wait that both
         * delayed registration far longer than needed and made host→child param
         * delivery depend on whether the child iframe booted faster or slower than
         * one second (#121880). Instead, look for the element as soon as the pending
         * digest completes and retry briefly if it is not there yet.
         *
         * `contentWindow` is a WindowProxy whose identity survives the child's own
         * navigations, so registering it this early is valid for the lifetime of the
         * element — and it is the same object the child's `mi:ChildReady` arrives
         * with, which is what keeps readiness intact in InteropService.
         */
        registerIframe(id: string) {
            this.id = id;
            this.resolveAndRegisterIframe(id, 1);
        }

        private static readonly IFRAME_LOOKUP_RETRY_MS = 50;
        private static readonly IFRAME_LOOKUP_MAX_ATTEMPTS = 60;

        private resolveAndRegisterIframe(id: string, attempt: number): void {
            const delay = attempt === 1 ? 0 : InteropController.IFRAME_LOOKUP_RETRY_MS;
            this.$timeout(() => {
                const element = document.getElementById(id.toString()) as HTMLIFrameElement;
                if (element && element.contentWindow) {
                    this.iframeElement = element;
                    this.interopService.registerWindow(id, element.contentWindow);
                    return;
                }
                if (attempt >= InteropController.IFRAME_LOOKUP_MAX_ATTEMPTS) {
                    this.loggingService.error(
                        `Interop iframe "${id}" never appeared in the DOM. Host-to-child context param delivery is unavailable for this context.`);
                    return;
                }
                this.resolveAndRegisterIframe(id, attempt + 1);
            }, delay);
        }

    }

    angular.module('meevo.plugins.interop')
        .controller('meevo.plugins.interop.InteropController', InteropController);
}
